import React from 'react';
import PropTypes from 'prop-types';
import { getCityStateZipDisplay, getGoogleMapsUrl } from '@general/helpers/address.helpers';
import { LinkSmall } from '@styled';
import { nonAsciiEscape } from '@general/chars';

const AddressBlock = ({ address }) => {
    const { address: address1, address2, address3 } = address;

    return (
        <>
            {address1 && (
                <>
                    {nonAsciiEscape(address1)}
                    <br />
                </>
            )}

            {address2 && (
                <>
                    {nonAsciiEscape(address2)}
                    <br />
                </>
            )}

            {address3 && (
                <>
                    {nonAsciiEscape(address3)}
                    <br />
                </>
            )}

            {getCityStateZipDisplay(address)}
            <br />

            <LinkSmall href={getGoogleMapsUrl(address)} target="_blank">
                View Map
            </LinkSmall>
        </>
    );
};

AddressBlock.propTypes = {
    address: PropTypes.shape({
        address: PropTypes.string,
        address2: PropTypes.string,
        address3: PropTypes.string,
        city: PropTypes.string,
        stateProvince: PropTypes.string,
        country: PropTypes.string,
        zip: PropTypes.string,
    }),
};

export default AddressBlock;
